// extracted by mini-css-extract-plugin
export default {"blank":"map_blank__6tDaX"};